export enum RouteEntity {
    Empty = '',
    Root = '/',
    SignIn = 'login',
    LogOut = 'logout',
    Main = 'main',
    PrintedTicket = 'printed-ticket',
    PrintedForm = 'printed-form',
    TopUp = 'top-up',
    SellProduct = 'sell-product',
    SellCard = 'sell-card',
    AddCard = 'add-card',
    RegistryCard = 'registry-card',
    SearchClient = 'search-client',
    Shift = 'shift',
}
